import { render, staticRenderFns } from "./Tray.vue?vue&type=template&id=5c2d4273"
import script from "./Tray.vue?vue&type=script&lang=js"
export * from "./Tray.vue?vue&type=script&lang=js"
import style0 from "./Tray.vue?vue&type=style&index=0&id=5c2d4273&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports